import {FaArrowTrendUp,FaArrowTrendDown} from "react-icons/fa6";
import "./StatsCard.css";

/**
 * Modern StatsCard (Policy Summary Style)
 */
const StatsCard = ({
  title,
  value,
  icon,
  iconColor = "primary",
  trend = null,
  trendLabel = "vs last sync",
  loading = false,
  onClick,
  className = "",
}) => {
  const formatValue = (val) => {
    if (val === null || val === undefined) return "—";
    if (typeof val === "number") return val.toLocaleString();
    return val;
  };

  return (
    <div
      className={`stats-card-modern ${onClick ? "clickable" : ""} ${className}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {loading ? (
        <div className="stats-card-loading">
          <div className=" skeleton stats-skeleton-value" />
          <div className="skeleton stats-skeleton-label" />
        </div>
      ) : (
        <>
          <div className="stats-card-header">
            <div className={`stats-card-icon icon-${iconColor}`}>
              {icon}
            </div>
            <span className={`stats-card-title icon-${iconColor}`} >{title}</span>
          </div>

          <div className="stats-card-value">
            {formatValue(value)}
          </div>

          {trend !== null && (
            <div
              className={`stats-card-trend ${
                trend >= 0 ? "trend-up" : "trend-down"
              }`}
            >
              {trend >= 0 ? <FaArrowTrendUp /> : <FaArrowTrendDown />}
              <span>{Math.abs(trend)}%</span>
              <span className="trend-label">{trendLabel}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default StatsCard;